export type UserData = {
  id: string;
  email: string;
  username: string;
} | null;

export interface TrackerMethods {
  init: () => boolean;
  setUserData: (userData: UserData) => void;
  captureException: (e: Error) => string | null | undefined;
}

export const TrackerPermission = {
  USER_DATA: 'USER_DATA',
} as const;

export type TrackerPermission = (typeof TrackerPermission)[keyof typeof TrackerPermission];
